export type AwardType =
  | {
      type: "icon";
      src: string;
      height: number;
    }
  | {
      type: "text";
      title: string;
    };

export type AwardGroup = {
  group: AwardType[];
};

export const AWARDS: AwardGroup[] = [
  {
    group: [
      {
        type: "text",
        title: "ТОП-100 \n работодателей 2025",
      },
      {
        type: "icon",
        src: "icon-forbes",
        height: 24,
      },
      {
        type: "icon",
        src: "icon-rbk",
        height: 23,
      },
    ],
  },
  {
    group: [
      {
        type: "text",
        title: "ТОП-200 \n работодателей 2025",
      },
      {
        type: "icon",
        src: "icon-hh",
        height: 40,
      },
    ],
  },
];
